var _style, _polygon, _polygon2, _rect, _polygon3, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoLectraDefCmjnWhiteRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 410.2 166.8",
    style: {
      enableBackground: "new 0 0 410.2 166.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#BE1622;}\r\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "63,102.8 63,56.6 55.3,56.6 55.3,102.8 55.3,110.5 63,110.5 93.7,110.5 93.7,102.8 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "116.7,87.4 132.1,87.4 132.1,79.7 109.1,79.7 109.1,87.4 109.1,102.8 109.1,110.5 116.7,110.5  147.5,110.5 147.5,102.8 116.7,102.8 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 109.1,
    y: 56.6,
    className: "st1",
    width: 38.4,
    height: 7.7
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "345.7,110.5 354.9,110.5 335.8,56.6 326.6,56.6 338.7,90.7 315.7,90.7 315.7,91.1 308.8,110.5  318,110.5 322.2,98.6 341.5,98.6 "
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 224.3,
    y: 72.1,
    className: "st0",
    width: 7.7,
    height: 38.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M196.7,96c-3.5,4.1-8.8,6.8-14.6,6.8c-10.6,0-19.2-8.6-19.2-19.2c0-10.6,8.6-19.2,19.2-19.2 c6.2,0,11.6,2.9,15.1,7.4l6-4.8c-4.9-6.3-12.6-10.3-21.1-10.3c-14.9,0-26.9,12.1-26.9,26.9s12,26.9,26.9,26.9 c8.4,0,15.8-3.8,20.8-9.8L196.7,96z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M289.5,88.8c5.3-2.9,9-8.6,9-15c0-9.4-7.6-17.1-17-17.2l0.1,0l-72.6,0l0,7.6l58.2,0c0,0,0,0,0,0l14.3,0 c5.3,0,9.6,4.3,9.6,9.6c0,5.2-4.1,9.5-9.3,9.7h-10.4V72l-8.6,0v20.8h0v17.6h8.6V92.8h0v-2.1h7.6c0.4,0.1,0.8,0.1,1.2,0.1l10.6,19.5 h10.3L289.5,88.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLectraDefCmjnWhiteRed);
export default __webpack_public_path__ + "static/media/Logo_Lectra_def_CMJN_white-red.ac95a247862eaa2724011b195dcd32f8.svg";
export { ForwardRef as ReactComponent };